export default class BlockSlider {
	static init() {

		let blocks = document.querySelectorAll('.block-slider, .block-rooms-slider, .block-residency-slider');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");
			let swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				spaceBetween: 20,
				speed: 600,
				breakpoints: {
					768: {
						slidesPerView: 1,
						spaceBetween: 20
					}
				},
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});
		});
	}
}
